import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningAlertComponent from '../../WarningAlert.component';
import { ChildAlertProps } from '../../BaseAlert.component';

const RecordRemoveAlertComponent = ({ handleConfirm }: ChildAlertProps) => {
  const { t } = useTranslation();

  return (
    <WarningAlertComponent onClose={handleConfirm}>
      {t('Record will be removed')}.
      <br />
      {t('Continue')}?
    </WarningAlertComponent>
  );
};

export default RecordRemoveAlertComponent;
